import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { IStateHotelAvailability } from './hotelAvailability.reducer';

const featureSelector = ({ hotelsAvailability }: AppState) => {
  return hotelsAvailability;
};

export const selectHotelAvailability = createSelector(
  featureSelector,
  ({ hotelAvailability }: IStateHotelAvailability) => hotelAvailability,
);

export const selectIsHotel = createSelector(
  featureSelector,
  ({ hotelAvailability }: IStateHotelAvailability) =>
    hotelAvailability && !hotelAvailability.isHomestay,
);

export const selectRoomFilters = createSelector(
  featureSelector,
  ({ filters }: IStateHotelAvailability) => {
    const comparator = (filter1, filter2) => filter1.order - filter2.order;
    const disabledFilters = filters.filter(f => f.disabled).sort(comparator);
    const enabledFilters = filters.filter(f => !f.disabled).sort(comparator);
    return enabledFilters.concat(disabledFilters);
  },
);

export const selectAreFiltersAvailable = createSelector(
  featureSelector,
  ({ filters }: IStateHotelAvailability) => filters.some(f => !f.disabled),
);

export const selectActiveRoomFilters = createSelector(
  featureSelector,
  ({ filters }: IStateHotelAvailability) => filters.filter((f) => f.active),
);

export const selectFilteredRooms = createSelector(
  featureSelector,
  ({ roomsFiltered, pageSize }: IStateHotelAvailability) =>
    roomsFiltered.slice(0, pageSize),
);

export const selectAllRooms = createSelector(
  featureSelector,
  ({ allRooms }: IStateHotelAvailability) => allRooms,
);

export const selectLoadingState = createSelector(
  featureSelector,
  ({ loading }: IStateHotelAvailability) => loading,
);

export const selectRoomDetailById = createSelector(
  featureSelector,
  (state, props: { roomId: string }) => state.roomDetails[props.roomId],
);

export const selectAreThereMoreRooms = createSelector(
  featureSelector,
  (state) => state.pageSize < state.roomsFiltered.length,
);

export const selectLegacyClusterByRoomName = createSelector(
  featureSelector,
  (state: IStateHotelAvailability, props: { roomName: string }) => ({
    cluster: state.disneyLegacyRooms.get(props.roomName),
    hotelName: state.hotelAvailability.name,
  }),
);
